import type { IShippingItem } from "@src/types/AppTypes";
import { Dispatch, createContext } from "react";

export const ShippingContext = createContext<IShippingItem[]>([]);
export const ShippingDispatchContext = createContext<
  Dispatch<{ type: "setShippingOptions"; payload: IShippingItem[] }>
>(() => {});

export const shippingReducer = (
  state: IShippingItem[],
  action: { type: "setShippingOptions"; payload: IShippingItem[] }
) => {
  if (action.type === "setShippingOptions") {
    return action.payload;
  } else {
    return state;
  }
};
